// Curated brand lists for the yacht / engine / generator pickers.
// Sorted alphabetically (case-insensitive). The picker lets users pick from
// the list OR type a custom value when their brand isn't here — keeping the
// data structured for the common case without locking out edge cases.

export const YACHT_BRANDS = [
  "Astondoa", "Azimut", "Baglietto", "Bavaria", "Beneteau", "Benetti",
  "Bertram", "Boston Whaler", "Burger", "Cantiere delle Marche", "Carver",
  "Catalina", "CL Yachts", "Chris-Craft", "Codecasa", "Cranchi", "Custom Line",
  "Dominator", "Dufour", "Elan", "Fairline", "Ferretti", "Fountaine Pajot",
  "Galeon", "Greenline", "Grand Banks", "Gulf Craft", "Hallberg-Rassy",
  "Hanse", "Hatteras", "Heesen", "Hinckley", "Horizon", "Hunter",
  "Jeanneau", "Lagoon", "Leopard", "Linssen", "Lürssen", "Magnum Marine",
  "Maiora", "Mangusta", "Maritimo", "Marquis", "Monte Carlo Yachts",
  "Moonen", "Mulder", "Nautor's Swan", "Nordhavn", "Numarine",
  "Oceanco", "Otam", "Overmarine", "Pacific Mariner", "Palmer Johnson",
  "Pershing", "Princess", "Prestige", "Riva", "Sanlorenzo", "Sea Ray",
  "Sealine", "Selene", "Sirena Yachts", "Sunreef", "Sunseeker",
  "Tankoa", "Tiara", "Trinity Yachts", "Viking", "Wally", "Wajer",
  "Westport", "Wider", "Wim van der Valk", "X-Yachts",
];

export const ENGINE_BRANDS = [
  "Caterpillar", "Cummins", "Detroit Diesel", "Deutz", "Doosan",
  "FPT", "Honda Marine", "Hyundai SeasAll", "Iveco", "John Deere",
  "MAN", "Mercury Marine", "MerCruiser", "MTU", "Nanni Diesel",
  "Perkins", "Scania", "Solé Diesel", "Steyr Motors", "Suzuki",
  "Tohatsu", "Volvo Penta", "Yamaha", "Yanmar",
];

export const GENERATOR_BRANDS = [
  "Caterpillar", "Cummins Onan", "FG Wilson", "Fischer Panda", "Generac",
  "John Deere", "Kohler", "MAN", "MTU", "Northern Lights",
  "Onan", "Paguro", "Perkins", "Phasor Marine", "Volvo Penta",
  "Westerbeke", "Whisper Power", "Yanmar",
];

export const STABILIZER_BRANDS = [
  "ABT-TRAC", "CMC Marine", "DMS Holland", "Humphree", "Mitsubishi",
  "Naiad Dynamics", "Quantum Stabilizers", "Quick", "Seakeeper",
  "Smartgyro", "VEEM", "WESMAR",
];
